import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Spinner } from 'reactstrap'

const SpinActionButton = ({
  classes = 'btn',
  iconClasses = 'ri-save-line',
  text = 'Guardar',
  color = 'primary',
  loading = false,
  onClick = () => {}
}) => {
  return !loading
    ? (
    <Button color={color} type="submit" className={classes} id="form-save" onClick={onClick}>
      {' '}
      <i className={iconClasses + ' ' + 'align-bottom me-1'}></i> {text}
    </Button>
      )
    : (
    <Button color={color} className={classes + ' btn-load'} disabled>
      <span className="d-flex align-items-center">
        <Spinner size="sm" className="flex-shrink-0"></Spinner>
        <span className="flex-grow-1 ms-2">{text}...</span>
      </span>
    </Button>
      )
}

SpinActionButton.propTypes = {
  classes: PropTypes.string,
  iconClasses: PropTypes.string,
  text: PropTypes.string,
  color: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func
}

export default SpinActionButton
